import { render } from "./TalentSearch.vue?vue&type=template&id=2bfde74e"
import script from "./TalentSearch.vue?vue&type=script&lang=js"
export * from "./TalentSearch.vue?vue&type=script&lang=js"

import "./TalentSearch.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__